import { gql } from "@apollo/client";

export const GET_TTS_VOICE_OPTIONS = gql`
  query getTtsVoiceOptions {
    getTtsVoiceOptions {
      id
      label
      gender
    }
  }
`;

export const GET_TTS_TONE_OPTIONS = gql`
  query getTtsToneOptions {
    getTtsToneOptions {
      id
      label
    }
  }
`;

export const GET_MY_TTS_PREFERENCES = gql`
  query getMyTtsPreferences {
    getMyTtsPreferences {
      voice
      toneId
    }
  }
`;
